import DashboardContentWrapper from './DashboardContentWrapper';

export default DashboardContentWrapper;
